export function formatCatalogPrice(value: any): string {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const parsed = parseFloat(value);
  if (!Number.isFinite(parsed)) {
    console.debug("[FIX][formatCatalogPrice] non-numeric value", { value });
    return "";
  }

  return `${parsed.toFixed(2)} ₽`;
}
